import React from "react";

import Accordion from "../../../components/shared/accordions/accordion";
import WhatsIncludedContent from "./whatsIncludedContent";
import WhatsExcluded from "./whatsExcluded";

const WhatsIncluded = ({
  whatsIncluded = [],
  whatsExcluded = [],
  groupsWhatsIncluded = [],
  groupsWhatsExcluded = [],
  hasProductType
}) => {
  return (
    <>
      <h2
        className="py-5 text-left text-[26px] sm:text-[32px] heading"
        dangerouslySetInnerHTML={{ __html: "What’s included?" }}
      />
      <div className="divide-y width-divider hidden sm:block" />
      <div className="mt-2 sm:mt-8">
        <Accordion
          title="What's included"
          controlClassName={
            "flex px-5 py-5 rounded-sm bg-yellow-lighter dark:bg-gray-darker"
          }
          textClassName={"text-std-med text-black-lighter dark:text-white"}
          content={
            <WhatsIncludedContent
              whatsIncluded={whatsIncluded}
              groupsWhatsIncluded={groupsWhatsIncluded}
              hasProductType={hasProductType}
            />
          }
        />

        <Accordion
          title="What's excluded"
          controlClassName={
            "flex px-5 py-5 rounded-sm bg-yellow-lighter dark:bg-gray-darker"
          }
          textClassName={
            "text-std-med sm:text-xl text-black-lighter dark:text-white"
          }
          content={
            <WhatsExcluded
              whatsExcluded={whatsExcluded}
              groupsWhatsExcluded={groupsWhatsExcluded}
            />
          }
        />
      </div>
    </>
  );
};

export default WhatsIncluded;
